import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { ShortNumberPipe } from '../../../../pipes/short-number.pipe';
import { SocialCreativeCard } from '../../types';

@Component({
    selector: 'app-social-creative-gallery-card',
    imports: [NgIf, ShortNumberPipe],
    templateUrl: './creative-gallery-card.component.html',
    styleUrl: './creative-gallery-card.component.scss',
})
export class SocialCreativeGalleryCardComponent {
    @Input() cardData!: SocialCreativeCard;

    private readonly AD_TYPE_LABELS: Record<string, string> = {
        video: 'Video Post',
        image: 'Image Post',
        dco: 'DCO Post',
    };

    protected get formattedAdType(): string {
        const key = this.cardData.adType?.toLowerCase();
        return this.AD_TYPE_LABELS[key] ?? this.cardData.adType;
    }

    protected get hasFacebook(): boolean {
        return this.cardData.platforms.includes('facebook');
    }

    protected get hasInstagram(): boolean {
        return this.cardData.platforms.includes('instagram');
    }
    protected get hasThreads(): boolean {
        return this.cardData.platforms.includes('threads');
    }
    protected get hasMessenger(): boolean {
        return this.cardData.platforms.includes('messenger');
    }

    protected get isVideo(): boolean {
        return this.cardData.adType?.toLowerCase() === 'video';
    }

    protected get formattedCpm(): string {
        return `$${this.cardData.cpm.toFixed(2)}`;
    }
}
